import React, { useState } from "react";

const transactions = [
  {
    id: 1,
    icon: "🚌",
    title: "Ride: Downtown Express",
    date: "Oct 24, 2024 • 08:30 AM",
    amount: "-$12.40",
    status: "Completed",
    type: "debit",
  },
  {
    id: 2,
    icon: "🎉",
    title: "Weekly Bonus",
    date: "Oct 23, 2024 • 06:00 PM",
    amount: "+$25.00",
    status: "Credited",
    type: "credit",
  },
  {
    id: 3,
    icon: "🏦",
    title: "Payout to Bank Account",
    date: "Oct 22, 2024 • 11:15 AM",
    amount: "-$150.00",
    status: "Processing",
    type: "debit",
  },
  {
    id: 4,
    icon: "🚗",
    title: "Ride: Airport Shuttle",
    date: "Oct 21, 2024 • 04:45 AM",
    amount: "-$32.00",
    status: "Completed",
    type: "debit",
  },
];

export default function HotelWallet() {
  const [balance] = useState("$245.50");

  return (
    <div style={styles.container}>
      {/* Balance Card */}
      <div style={styles.card}>
        <p style={styles.balanceLabel}>AVAILABLE BALANCE</p>
        <h1 style={styles.balanceAmount}>{balance}</h1>

        <div style={styles.buttonRow}>
          <button
            style={styles.cashoutBtn}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e0e0e0")}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#ebebeb")}
          >
            <span style={styles.bankIcon}>🏛</span> Cashout
          </button>
        </div>
      </div>

      {/* Recent Activity Card */}
      <div style={styles.card}>
        <div style={styles.activityHeader}>
          <h2 style={styles.activityTitle}>Recent Activity</h2>
          <button style={styles.viewHistoryBtn}>View History</button>
        </div>

        <div>
          {transactions.map((txn, index) => (
            <div
              key={txn.id}
              style={{
                ...styles.txnRow,
                borderBottom:
                  index < transactions.length - 1
                    ? "1px solid #f0f0f0"
                    : "none",
              }}
            >
              <div style={styles.txnLeft}>
                <div style={styles.txnIconWrap}>
                  <span style={styles.txnIcon}>{txn.icon}</span>
                </div>
                <div>
                  <p style={styles.txnTitle}>{txn.title}</p>
                  <p style={styles.txnDate}>{txn.date}</p>
                </div>
              </div>
              <div style={styles.txnRight}>
                <p
                  style={{
                    ...styles.txnAmount,
                    color: txn.type === "credit" ? "#22c55e" : "#ef4444",
                  }}
                >
                  {txn.amount}
                </p>
                <p
                  style={{
                    ...styles.txnStatus,
                    color:
                      txn.status === "Processing"
                        ? "#f59e0b"
                        : txn.status === "Credited"
                        ? "#22c55e"
                        : "#6b7280",
                  }}
                >
                  {txn.status}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    paddingTop: "74px",
    paddingLeft: "58px",
    paddingBottom: "0px",
    paddingRight: "0px",
    maxWidth: "780px",   // ← reduced from 900px
    width: "100%",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    boxSizing: "border-box",
  },
  card: {
    backgroundColor: "#ffffff",
    border: "1px solid #e8e8e8",
    borderRadius: "16px",
    padding: "28px 32px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },
  balanceLabel: {
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.1em",
    color: "#9ca3af",
    margin: "0 0 8px 0",
    textTransform: "uppercase",
  },
  balanceAmount: {
    fontSize: "40px",
    fontWeight: "700",
    color: "#111827",
    margin: "0 0 28px 0",
    letterSpacing: "-0.5px",
  },
  buttonRow: {
    display: "flex",
    gap: "12px",
  },
  topUpBtn: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "#111",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "14px 20px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.15s ease",
  },
  cashoutBtn: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "#ebebeb",
    color: "#374151",
    border: "none",
    borderRadius: "10px",
    padding: "14px 20px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.15s ease",
  },
  plusIcon: {
    fontSize: "17px",
    lineHeight: 1,
  },
  bankIcon: {
    fontSize: "16px",
    lineHeight: 1,
  },
  activityHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  activityTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#111827",
    margin: 0,
  },
  viewHistoryBtn: {
    background: "none",
    border: "none",
    color: "#3b82f6",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    padding: "0",
  },
  txnRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 0",
  },
  txnLeft: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  txnIconWrap: {
    width: "42px",
    height: "42px",
    backgroundColor: "#f3f4f6",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  txnIcon: {
    fontSize: "18px",
  },
  txnTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#111827",
    margin: "0 0 3px 0",
  },
  txnDate: {
    fontSize: "12px",
    color: "#9ca3af",
    margin: 0,
  },
  txnRight: {
    textAlign: "right",
  },
  txnAmount: {
    fontSize: "15px",
    fontWeight: "700",
    margin: "0 0 3px 0",
  },
  txnStatus: {
    fontSize: "12px",
    fontWeight: "500",
    margin: 0,
  },
};
